<template>
  <div id="app">
    <input v-model="number" placeholder="Enter phone number" />
    <textarea v-model="message" placeholder="Enter message"></textarea>
    <button @click="sendMessage">Send Message</button>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      number: '',
      message: ''
    };
  },
  methods: {
    async sendMessage() {
      try {
        const response = await axios.post('http://localhost:3000/send-message', {
          number: this.number,
          message: this.message
        });

        if (response.data.success) {
          alert('Message sent successfully');
        } else {
          alert('Failed to send message: ' + response.data.error);
        }
      } catch (error) {
        console.error('Error:', error);
        alert('An error occurred: ' + error.message);
      }
    }
  }
};
</script>

<style>
/* Add your styles here */
</style>
